import cn from "@utils/cn";
import { Router } from "@utils";
import Avatar from "@elements/Avatar";

const CLASS_NAMES = cn(`
  flex
  items-center
  w-full
  gap-3
  px-6
  py-4
  transition-colors

  text-(--navbar-foreground-color)

  hover:bg-black/20
`);

const LABEL_CLASS_NAMES = cn(`
  text-base
  font-medium
`);

export default function UserProfileDrawerItem(props) {
  const {
    userName,
    userAvatarUrl,
    closeDrawer,
  } = props;

  const handleClick = () => {
    closeDrawer();
    Router.redirectToPath("/profile");
  };

  return (
    <button
      className={CLASS_NAMES}
      onClick={handleClick}
    >
      <Avatar
        url={userAvatarUrl}
        size="2rem"
      />

      <span className={LABEL_CLASS_NAMES}>
        {userName}
      </span>
    </button>
  );
}
